import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuOutlined } from "@ant-design/icons";
export function AdminLogo() {
    const toggleMenu = () => {
        const menu = document.getElementById("x-ui-admin-menu");
        if (menu.classList.contains("x-ui-admin-menu-close")) {
            menu.classList.remove("x-ui-admin-menu-close");
            menu.classList.add("x-ui-admin-menu-open");
            localStorage.setItem("menu-status", "open");
        }
        else if (menu.classList.contains("x-ui-admin-menu-open")) {
            menu.classList.remove("x-ui-admin-menu-open");
            menu.classList.add("x-ui-admin-menu-close");
            localStorage.setItem("menu-status", "close");
        }
    };
    return (_jsxs("div", Object.assign({ className: "x-ui-admin-logo" }, { children: [_jsx("button", Object.assign({ className: "x-ui-admin-menu-toggle", onClick: toggleMenu }, { children: _jsx(MenuOutlined, { style: { fontSize: 18 } }, void 0) }), void 0), _jsx("img", { src: "/public/wp-energy-logo-2.png", alt: "wpenergy-logo" }, void 0), _jsx("p", { children: "WPEnergy" }, void 0)] }), void 0));
}
